/* React hooks */
import {useEffect, useState} from "react";
/* Components */
import useAuth from "../../hooks/useAuth";
import {getEstimateCatInfos, updateEstimateCatInfos} from "../../api/admin/estimateReq";
import FormButtons from "../../components/common/FormButtons";
import {
    checkRequiredFields,
    getErrorListFromValidation,
    removeErrorList,
    validateFormInput
} from "../../helper/tools";
import Icon from "../../components/common/Icon";

export default function FormEstimateCategory({ apiEstimateCatList, catId, legend, setShowModal }) {

    const [ estimateCategoryInfos, setEstimateCategoryInfos ] = useState();
    const { auth } = useAuth();
    const token = auth.token;
    const [ values, setValues ] = useState();

    const onChange = (e) => {
        setValues({...values, [e.target.name] : e.target.value})
        validateFormInput(e)
    };

    const handleRemoveForm = () => {
        setShowModal(false)
    };

    const apiEstimateCatInfos = async () => {
        const response = await getEstimateCatInfos(token, catId);
        setEstimateCategoryInfos(response);
    };

    useEffect(() => {
        apiEstimateCatInfos()
    }, [ catId ]);

    useEffect(() => {
        setValues(estimateCategoryInfos)
    }, [ estimateCategoryInfos ]);

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!checkRequiredFields()) {
            return;
        }
        let body = {
            id: parseInt(catId),
            code: parseInt(values?.code),
            description: values?.description,
        }
        await updateEstimateCatInfos(token, body)
            .then((response) => {
                removeErrorList()
                if (!response?.response?.data?.error) {
                    setShowModal(false)
                    apiEstimateCatInfos()
                    apiEstimateCatList()
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            })
    };

    return (
                <form onSubmit={handleSubmit} method="POST" noValidate>
                    <fieldset className="mini">
                        <Icon source="fa fa-table-list" span={legend} />
                        <div className="form-input">
                            <label htmlFor="code">Code (le code est un nombre compris entre 1 et 99)</label>
                            <input required pattern="^[0-9]{1,2}$" type="text" name="code" value={values?.code} onChange={onChange}/>
                        </div>
                        <div className="form-input">
                            <label htmlFor="description">Description</label>
                            <textarea name="description" id="description" value={values?.description} onChange={onChange}/>
                        </div>

                        <div className="errors"></div>
                    </fieldset>
                    <div className="buttons-container">
                        <FormButtons handleRemoveModal={handleRemoveForm}/>
                    </div>
                </form>

    )
}